// All money fields are USD, never UAH/грн — explicit late change from the business owner
// (AGENTS.md §6.2).
const formatter = new Intl.NumberFormat("uk-UA", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return formatter.format(value);
}
